module.exports = __webpack_public_path__ + "static/media/36.fb918cec.gif";